/** @format */
import mixedUtils from './utils';
import lodash from 'lodash';
export default {
  data() {
    return {
      initialValueCopy: null
    };
  },
  watch: {
    model(nv, ov) {
      mixedUtils.log('old nv--:', nv);
      try {
        if (typeof this.transformedAttrs.modelTransfer === 'function') {
          nv = this.transformedAttrs.modelTransfer(nv);
        }
        mixedUtils.log('model ov and nv--:', ov, nv, this.transformedAttrs);
      } catch (e) {
        void 0;
      }

      this.$emit('modelUpdate', nv, this.compDefine);
      if (!this.where) {
        mixedUtils.log('update v for null where--:', nv);

        return false;
      }

      mixedUtils.log('watch invoked', nv);
      mixedUtils.log('this in model watch--:', this, this.getClosestVM());
      mixedUtils.log('targt-- in watch:', this.getTargetItemByUuid());
      try {
        this.getTargetItemByUuid().initialValue = nv;
      } catch (e) {
        console.warn('watch model e--:', e);
      }

      this.updateModel();
    }
  },
  methods: {
    updateModel() {
      // console.trace()
      try {
        let v = this.getTargetItemByUuid().initialValue;
        mixedUtils.log('更新:' + this.where + ',httpKey:' + this.compDefine.attrs.httpKey + ',v:', v);

        this.getClosestVM().evtBus.$emit('B_UPDATE_DATE_BY_DYNAMIC_COMP', {
          where: this.where,
          compDefine: this.compDefine,
          v: v
        });
      } catch (e) {
        console.warn('updae model e--:', e);
      }
    },
    clearValue() {
      mixedUtils.log('clear value invoked');

      let target = this.getTargetItemByUuid();

      if ('tempData4FilterParamGenerate' in target) {
        target.tempData4FilterParamGenerate = lodash.cloneDeep(this.tempData4FilterParamGenerateCopy);
      }

      switch (this.compDefine.reflect || this.compDefine.comp) {
        case 'TableFilterItem.PlateInput': {
          this.model = true;

          // this.compDefine.initialValue = true
          this.$refs.myDynamicComp.plateHead = '';
          this.$refs.myDynamicComp.plateTail = '';
          break;
        }

        default: {
          this.model = lodash.cloneDeep(this.initialValueCopy);
          mixedUtils.log('ref--:', this.$refs.myDynamicComp);
          if (
            this.$refs.myDynamicComp instanceof window.HTMLElement &&
            this.$refs.myDynamicComp.nodeName.toLowerCase() == 'input'
          ) {
            this.$refs.myDynamicComp.value = this.model;
          }
          mixedUtils.log('default invoked');
          break;
        }
      }
      try {
        //清除date range显示问题
        this.$refs.myDynamicComp.$refs.picker.setValue([undefined, undefined]);
      } catch (e) {
        void 0;
      }
    },
    getClosestVM() {
      // mixedUtils.log('get closest vm invoked', this)
      // debugger
      let res = this.vm || mixedUtils.closestVM(this, 'filterParam');

      if (process.env.NODE_ENV != 'production') {
        window.lastClosestedVM = res;
      }

      return res;

      // return this.vm || mixedUtils.closestVM(this, 'filterParam')
    },

    getTargetItemByUuid() {
      mixedUtils.log('comp define uuid and where', this.compDefine.uuid, this.where, this.compDefine.comp);
      return this.getClosestVM().getTargetByUUidAndWhere(this.compDefine.uuid, this.where);
    },
    resetInitialValue() {
      this.getTargetItemByUuid().initialValue = this.getClosestVM().lodash.cloneDeep(this.initialValueCopy);
    }
  },

  // beforeDestroy() {
  //   alert('will delete')
  //   delete this.getClosestVM().dynamicCompInstanceCollectionInDialog[this.compDefine.uuid]
  // },
  created() {
    let vm = this.getClosestVM();
    vm.detailModel != null && (vm.dynamicCompInstanceCollectionInDialog[this.compDefine.uuid] = this);
    mixedUtils.log('this vvvvvvvvvmmmm--:', this.vm);
    // mixedUtils.log(' this.getClosestVM()--:', this.getClosestVM())
    this.$nextTick(() => {
      this.initialValueCopy = lodash.cloneDeep(this.model);
    });
  }
};
